// extracted by mini-css-extract-plugin
module.exports = {"new":"view-default_new_3pdV1","dangerous":"view-default_dangerous_3Pv4w"};